export const parseEntitiesIndustries = entities => [
  ...new Set(entities.map(({ industryClassification }) => industryClassification)),
];
